import NewsFeed from "./Feed.vue";
import FeedIndex from "./IndexPage.vue";

export default [
  {
    path: "/feed",
    component: FeedIndex,
    redirect: "/feed",
    name: "feed",
    children: [
      {
        path: "feed",
        component: NewsFeed,
        name: "news.feed",
      },
    ],
  },
];
